export const PUB_FILTERS = [
  { key: "unpublished", label: "Sin publicar", test: (r) => !r.show_in_storefront },
  { key: "ready", label: "Listos (100%)", test: (r) => r.readiness.ready && !r.show_in_storefront },
  { key: "almost", label: "Falta poco", test: (r) => !r.readiness.ready && r.readiness.score >= 60 },
  { key: "no_photo", label: "Sin foto", test: (r) => !r.photo },
  { key: "published", label: "Publicados", test: (r) => r.show_in_storefront },
  { key: "all", label: "Todos con stock", test: () => true },
];

export const fmtMxn = (n) => `MX$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

// Etiquetas cortas para los chips de "qué falta".
export const shortMissing = (m) => {
  const map = { photos: "Foto", use_cases: "Uso ideal", short_tagline: "Slogan", store_price: "Precio tienda", name: "Nombre", category: "Categoría", specs: "Ficha" };
  if (map[m.key]) return map[m.key];
  if (m.key.startsWith("spec_")) return m.label.replace("Ficha técnica: ", "");
  return m.label;
};

// Lo que la IA puede completar vs. lo que requiere acción manual (foto, precio).
export const AI_FIXABLE = (m) => m.key === "use_cases" || m.key === "short_tagline" || m.key === "specs" || m.key.startsWith("spec_");

export const scoreTone = (score, ready) => {
  if (ready) return { bar: "bg-emerald-500", text: "text-emerald-700" };
  if (score >= 60) return { bar: "bg-amber-500", text: "text-amber-700" };
  return { bar: "bg-[#E0000F]", text: "text-[#E0000F]" };
};

export const norm = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
